import React from "react";
import PropTypes from "prop-types";

import { styled, alpha } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ExpandCircleDownOutlinedIcon from "@mui/icons-material/ExpandCircleDownOutlined";
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import Checkbox from "@mui/material/Checkbox";
import { Chip, Stack } from "@mui/material";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 200,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

const BootstrapButton = styled(Button)({
  boxShadow: "none",
  textTransform: "none",
  fontSize: 16,
  padding: "10px 22px",
  border: "2px solid",
  lineHeight: 1.5,
  backgroundColor: "#fff",
  color: "#637381",
  borderColor: "rgba(145, 158, 171, 0.24)",
  fontFamily: "Poppins",
  fontWeight: 500,
  maxHeight:'52px',
  "&:hover": {
    backgroundColor: "#fff",
    borderColor: "#37B34A",
    boxShadow: "none",
  },
  "&:active": {
    boxShadow: "none",
    backgroundColor: "#fff",
    borderColor: "#37B34AB5",
  },
  "&:focus": {
    boxShadow: "0 0 0 0.2rem #37B34AB5",
  },
});

const AlternativeChannel = (props) => {
  const {
    buttonName,
    alternativeChannelObj,
    alternativeChannelChecked,
    setAlternativeChannelChecked,
    handleOrderChangeAlternative,
    t,
  } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // const handleOrderChange = (event) => {
  //   if([event.target.name] == 'offerEnable'){
  //     setAlternativeChannelChecked({
  //       ...alternativeChannelObj,
  //       ['offerEnable']: true,
  //       ['offerAvialable']: false
  //     });
  //   }else{
  //     setAlternativeChannelChecked({
  //       ...alternativeChannelObj,
  //       ['offerEnable']: false,
  //       ['offerAvialable']: true
  //     });
  //   }
  // };

  const activeOrder = React.useMemo(() => {
    const activeFilter = Object.keys(alternativeChannelChecked).filter(
      (p) => alternativeChannelChecked[p] === true
    );
    return activeFilter;
  }, [alternativeChannelChecked]);

  return (
    <div>
      <BootstrapButton
        id="demo-customized-button"
        aria-controls={open ? "demo-customized-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        variant="contained"
        disableElevation
        onClick={handleClick}
        endIcon={<ExpandCircleDownOutlinedIcon />}
      >
        {t(buttonName)}{" "}
        <Chip
          sx={{
            backgroundColor:  "transparent",
            color: "#1B727E",
            m: "5px",
            "& .MuiChip-label": { fontWeight: "bold" },
          }}
          label={ ""}
          size={"medium"}
          component="span"
        />
      </BootstrapButton>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <Stack
          direction={"column"}
          alignItems={"flex-start"}
          sx={{ width: "100%" }}
        >
          <FormControl
            component="fieldset"
            variant="standard"
            sx={{ width: "100%" }}
          >
            {/* <FormLabel
              component="legend"
              sx={{ ml: "24px", mt: 1, textTransform: "uppercase" }}
            >
              {t("list")}
            </FormLabel> */}
            <FormGroup sx={{ width: "100%" }}>
              {Object.keys(alternativeChannelObj).map((item) => (
                <MenuItem
                  key={item}
                  disableRipple
                  sx={{ width: "100%", justifyContent: "space-between" }}
                >
                  <FormControlLabel
                    labelPlacement="start"
                    control={
                      <Checkbox
                        name={item}
                        checked={alternativeChannelChecked[item]}
                        onChange={handleOrderChangeAlternative}
                        inputProps={{ "aria-label": "controlled" }}
                        icon={<RadioButtonUncheckedIcon />}
                        checkedIcon={<CheckCircleIcon />}
                        sx={{
                          p: 0,
                          m: 0,
                          ml: 2,
                          justifyContent: "space-between",
                          "& .MuiSvgIcon-root": {
                            fontSize: "28px !important",
                            color: "#37B34A !important",
                            mr: "0px !important",
                          },
                        }}
                      />
                    }
                    sx={{
                      width: 1,
                      justifyContent: "space-between",
                      ml: "10px",
                      mr: 1,
                    }}
                    label={t(`${item}`)}
                  />
                </MenuItem>
              ))}
            </FormGroup>
          </FormControl>
        </Stack>
      </StyledMenu>
    </div>
  );
};

AlternativeChannel.propTypes = {
  alternativeChannelObj: PropTypes.object,
  alternativeChannelChecked: PropTypes.object,
  setAlternativeChannelChecked: PropTypes.func,
  t: PropTypes.func,
};

export default AlternativeChannel;
